import React from 'react';
import Symbols from './symbols.svg';

export default () => <Symbols />
